import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import {secureStorage} from "../../shared/functions/secure-storage";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root',
})
export class ExpiredPasswordGuard implements CanActivate {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userInfo = secureStorage.getItem('userProfile');
    if (userInfo) {
      // logged in so return true
      if (userInfo?.expieredPssword) {
        const title = this.translate.instant('Password expired!')
        const msg = this.translate.instant('You have to change your password')
        this.toastr.warning(msg, title);
        this.router.navigate(['/change-password'], {queryParams: {change: secureStorage.getItem('expire')}});
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
